import { addToCart } from '~/js/lib/cart'; // eslint-disable-line

export default (node) => {
  const shopifyStorefrontURL = node.dataset.storefrontUrl;
  const accessToken = node.dataset.accessToken;
  let products = null;

  const findProductsButton = node.querySelector('[data-find-products]');
  const resultsNumber = node.querySelector('[data-results-number]');
  const collectionHandle = node.dataset.collectionHandle;
  const noResultsText = node.dataset.noResultsText;
  const resultsText = node.dataset.resultsText;
  const addToCartText = node.dataset.addToCartText;
  const resultsTextDiv = node.querySelector('[data-results-text-div]');
  const totalWidthText = node.dataset.totalWidthText;
  const closetKitText = node.dataset.closetKitText;
  const moneyFormat = node.dataset.moneyFormat.replace(
    'amount_with_dot_separator',
    'amount'
  );
  const widthRange = node.querySelector('[data-filter-width]');
  const filterDepth = node.querySelector('[data-filter-depth]');

  // graphql query to fetch all products
  const fetchAllProducts = async () => {
    const query = `
    {
      collection (handle:"${collectionHandle}") {
        id
        products(first: 250, filters: {available: true}) {
          edges {
            node {
              id
              title
              vendor
              variants(first: 250) {
                edges {
                  node {
                    id
                    availableForSale
                    price {
                      amount
                      currencyCode
                    }
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                    image {
                      url (transform:{maxWidth: 220})
                    }
                    quantityAvailable
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
              handle
              metafields(identifiers: [{key: "color-pattern", namespace: "shopify"}, {key: "width", namespace: "custom"}, {key: "depth", namespace: "custom"}, {key: "style", namespace: "custom"}, {key: "image_closet_configurator", namespace: "custom"}]
              ) {
                id
                references(first: 250) {
                  edges {
                    node {
                      ... on Metaobject {
                        id
                        fields {
                          value
                          key
                          reference {
                            ... on MediaImage {
                              id
                              image {
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                value
                key
                reference {
                  ... on MediaImage {
                    id
                    image {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

    const response = await fetch(shopifyStorefrontURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({ query }),
    });

    const data = await response.json();

    const products = data.data.collection.products.edges.map(
      (edge) => edge.node
    );
    return products;
  };

  // apply filter by color
  const filterDataColor = (data, color) => {
    return data.filter((productArray) => {
      if (productArray && productArray.length > 0) {
        return productArray.some((product) => {
          if (product && product.variants && product.variants.edges) {
            return product.variants.edges.some((edge) => {
              if (
                edge &&
                edge.node &&
                edge.node.selectedOptions &&
                edge.node.availableForSale
              ) {
                return edge.node.selectedOptions.some((option) => {
                  return option.name === 'Color' && option.value === color;
                });
              }
              return false;
            });
          }
          return false;
        });
      }
      return false;
    });
  };

  // apply filter by depth
  const filterDataDepth = (data, depth) => {
    return data.filter((productArray) => {
      if (productArray && productArray.length > 0) {
        return productArray.some((product) => {
          if (product && product.depth) {
            return Number(product.depth) <= Number(depth);
          }
          return false;
        });
      }
      return false;
    });
  };

  // apply filter by shelf style
  const filterDataShelf = (data, shelfStyles) => {
    return data.filter((productArray) => {
      if (productArray && productArray.length > 0) {
        return productArray.some((product) => {
          if (product && product.shelf && product.shelf.length > 0) {
            return product.shelf.some((item) => {
              return shelfStyles.includes(item);
            });
          }
          return false;
        });
      }
      return false;
    });
  };

  // find products based on filters
  const findProducts = async () => {
    const filterWidth = node.querySelector('[data-filter-width]').value;
    const filterDepth = node.querySelector('[data-filter-depth]').value;
    const filterShelf = Array.from(
      node.querySelectorAll(
        '[data-filter-shelf] input[type="checkbox"]:checked'
      )
    ).map((input) => input.value);

    const filterColor = node
      .querySelector('[data-filter-color]')
      .querySelector('input[type="radio"]:checked').value;

    // get the width in a separate property
    let results = products.map((item) => {
      const width = item.metafields.find((metafield) => {
        if (metafield && metafield.key === 'width') {
          return metafield.value;
        } else {
          return false;
        }
      });

      return {
        ...item,
        width: width ? Number(width.value) : 0,
      };
    });

    // get the depth in a separate property
    results = results.map((item) => {
      const depth = item.metafields.find((metafield) => {
        if (metafield && metafield.key === 'depth') {
          return metafield.value;
        } else {
          return false;
        }
      });

      return {
        ...item,
        depth: depth ? Number(depth.value) : 0,
      };
    });

    // get the shelf style in a separate property
    results = results.map((item) => {
      const shelfStyle = item.metafields.find((metafield) => {
        if (metafield && metafield.key === 'style') {
          return metafield.references.edges;
        } else {
          return false;
        }
      });

      let shelfArray = [];
      if (shelfStyle) {
        shelfStyle.references.edges.forEach((shelf) => {
          shelf.node.fields.forEach((field) => {
            if (field.key === 'label') {
              shelfArray.push(field.value);
            }
          });
        });
      }

      return {
        ...item,
        shelf: shelfArray && shelfArray.length > 0 ? shelfArray : null,
      };
    });

    const validCombinations = findAllCombinationsWithMeetInTheMiddle(
      results,
      filterWidth
    );

    // filter by color
    if (!filterColor) {
      renderResults(validCombinations);
      return;
    }
    const filteredCombinations = filterDataColor(
      validCombinations,
      filterColor
    );

    // filter by Depth
    if (filterDepth.length === 0) {
      renderResults(filteredCombinations);
      return;
    }
    const filteredCombinationsDepth = filterDataDepth(
      filteredCombinations,
      filterDepth
    );

    // filter by shelf style
    if (filterShelf.length === 0) {
      renderResults(filteredCombinationsDepth);
      return;
    }
    const filteredCombinationsShelf = filterDataShelf(
      filteredCombinationsDepth,
      filterShelf
    );

    renderResults(filteredCombinationsShelf);
  };

  // render results
  const renderResults = (results) => {
    const dataResults = node.querySelector('[data-results-configurator]');
    dataResults.innerHTML = '';

    results.forEach((result, indexResults) => {
      const productContainer = document.createElement('div');
      productContainer.classList.add(
        'flex',
        'flex-col',
        'gap-6',
        'md:flex-row'
      );

      const product = document.createElement('div');
      product.classList.add('grid', 'grid-cols-1', 'gap-3', 'basis-[55%]');

      const titleContainer = document.createElement('div');
      titleContainer.classList.add('flex', 'flex-col', 'gap-2');
      const mainTitle = document.createElement('h2');
      mainTitle.classList.add(
        'text-display-xs-regular',
        'md_lg:text-display-sm-regular'
      );
      mainTitle.innerHTML = `${closetKitText} ${indexResults + 1}`;
      titleContainer.appendChild(mainTitle);

      const kitTitle = document.createElement('h3');
      kitTitle.classList.add('text-lg');
      kitTitle.innerHTML = `${totalWidthText}: <span class="text-black">#TOTALWIDTH#</span>`;
      kitTitle.classList.add('text-lg-medium', 'text-gray-60');
      titleContainer.appendChild(kitTitle);
      product.appendChild(titleContainer);

      let totalWidth = 0;
      let totalPrice = 0;
      let variantIds = [];

      variantIds = [];
      const productMainImages = [];

      result.forEach((oneProduct) => {
        if (oneProduct.metafields) {
          const resultWidth = oneProduct.metafields.some((metafield) => {
            if (metafield && metafield.key && metafield.key === 'width') {
              totalWidth += Number(metafield.value);
              return true;
            }
            return 0;
          });

          oneProduct.metafields.forEach((metafield) => {
            if (
              metafield &&
              metafield.key &&
              metafield.key === 'image_closet_configurator'
            ) {
              productMainImages.push(metafield.reference.image.url);
            }
          });
        }

        // get the variant ids
        variantIds.push(
          oneProduct.variants.edges[0].node.id.replace(
            'gid://shopify/ProductVariant/',
            ''
          )
        );

        if (oneProduct.variants && oneProduct.variants.edges) {
          const resultWidth = oneProduct.variants.edges.some((oneVariant) => {
            if (
              oneVariant &&
              oneVariant.node &&
              oneVariant.node.price &&
              oneVariant.node.price.amount
            ) {
              totalPrice += Number(oneVariant.node.price.amount);
              return true;
            }
            return 0;
          });
        }

        const oneProductDiv = document.createElement('div');
        oneProductDiv.classList.add('flex', 'flex-row', 'gap-3');
        //image
        const productImage = document.createElement('img');
        productImage.src = oneProduct.variants.edges[0].node.image.url;
        productImage.alt = oneProduct.title;
        productImage.classList.add('w-[120px]', 'h-full', 'object-contain');
        oneProductDiv.appendChild(productImage);
        // title
        const productTitleContainer = document.createElement('div');
        productTitleContainer.classList.add('flex', 'flex-col', 'gap-4');
        const productTitle = document.createElement('a');
        productTitle.href = `/products/${oneProduct.handle}`;
        productTitle.classList.add('text-lg-medium');
        productTitle.textContent = oneProduct.title;
        productTitleContainer.appendChild(productTitle);
        // price
        const productPriceContainer = document.createElement('div');
        productPriceContainer.classList.add(
          'flex',
          'flex-row-reverse',
          'gap-2',
          'items-center',
          'justify-end'
        );

        const productPrice = document.createElement('p');
        productPrice.classList.add('text-md-medium', 'py-2');
        if (
          oneProduct.variants.edges[0].node.compareAtPrice &&
          oneProduct.variants.edges[0].node.compareAtPrice.amount !==
            oneProduct.variants.edges[0].node.price.amount
        ) {
          productPrice.classList.add('text-carmine');
        }

        const priceFormatProduct = Shopify.formatMoney(
          oneProduct.variants.edges[0].node.price.amount,
          moneyFormat
        );

        productPrice.textContent = priceFormatProduct;
        productPriceContainer.appendChild(productPrice);

        if (
          oneProduct.variants.edges[0].node.compareAtPrice &&
          oneProduct.variants.edges[0].node.compareAtPrice.amount !==
            oneProduct.variants.edges[0].node.price.amount
        ) {
          const productComparePrice = document.createElement('p');
          productComparePrice.classList.add(
            'text-md-medium',
            'py-2',
            'line-through'
          );
          const priceFormatProductCompare = Shopify.formatMoney(
            Number(oneProduct.variants.edges[0].node.compareAtPrice.amount) *
              100,
            moneyFormat
          );
          productComparePrice.textContent = priceFormatProductCompare;
          productPriceContainer.appendChild(productComparePrice);
        }

        productTitleContainer.appendChild(productPriceContainer);

        oneProductDiv.appendChild(productTitleContainer);

        product.appendChild(oneProductDiv);
      });

      // update the total width
      product.innerHTML = product.innerHTML.replace('#TOTALWIDTH#', totalWidth);

      // add to cart button
      const addToCartContainer = document.createElement('div');
      addToCartContainer.classList.add('flex', 'flex-row', 'gap-3');

      const addToCartButton = document.createElement('button');
      addToCartButton.classList.add(
        'button',
        'bg-cart',
        'py-3',
        'px-5',
        'h-10',
        'text-md-bold',
        'text-gray-90',
        'rounded-lg',
        'w-full',
        'flex',
        'flex-row',
        'gap-2',
        'items-center',
        'justify-center'
      );
      addToCartButton.setAttribute('data-closet-add-to-cart', variantIds);
      totalPrice = totalPrice * 10;
      const priceFormat = Shopify.formatMoney(totalPrice, moneyFormat);
      addToCartButton.innerHTML =
        addToCartText +
        `<span class="text-sm-regular pt-1">${priceFormat}</span>`;
      addToCartContainer.appendChild(addToCartButton);
      addToCartContainer.classList.add('flex', 'flex-row', 'gap-2');

      product.appendChild(addToCartContainer);

      // add grouped image
      const divMainImage = document.createElement('div');
      divMainImage.classList.add(
        'flex',
        'flex-row',
        'gap-0',
        'px-[30px]',
        'max-h-[400px]',
        'w-full',
        'h-auto'
      );

      const imageContainer = document.createElement('div');
      imageContainer.classList.add(
        'w-full',
        'relative',
        'p-[30px]',
        'basis-[45%]',
        'inline-flex',
        'items-center',
        'justify-center',
        'bg-gray-05',
        'rounded-lg'
      );
      // add a canvas
      const canvas = document.createElement('canvas');
      canvas.classList.add(
        'w-full',
        'h-auto',
        'block',
        'max-w-max',
        'max-h-[432px]'
      );
      canvas.height = 432;
      canvas.width = 372;
      const ctx = canvas.getContext('2d');

      if (productMainImages.length > 0) {
        const listImages = [];

        productMainImages.forEach((image) => {
          listImages.push(image);
        });

        Promise.all(listImages.map((src) => loadImage(src)))
          .then((images) => {
            // Calculate the total width and max height
            const totalWidth = images.reduce((sum, img) => sum + img.width, 0);
            const maxHeight = Math.max(...images.map((img) => img.height));

            // Set canvas size
            canvas.width = totalWidth;
            canvas.height = maxHeight;

            // Draw each image side by side
            let currentX = 0;
            images.forEach((img) => {
              ctx.drawImage(img, currentX, 0, img.width, img.height);
              currentX += img.width;
            });
          })
          .catch((error) => {
            console.error('Error loading images:', error);
          });
      }

      imageContainer.appendChild(canvas);

      productContainer.appendChild(imageContainer);

      // add individual product
      productContainer.appendChild(product);

      dataResults.appendChild(productContainer);
    });

    // check if not results
    if (results.length === 0) {
      resultsTextDiv.textContent = noResultsText;
      resultsNumber.textContent = ``;
    } else {
      resultsTextDiv.textContent = resultsText;
      resultsNumber.textContent = `(${results.length})`;
    }

    addEventListenerToAddToCart();
  };

  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // Important for external images
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  };

  // Function to find all combinations of products with a total width <= totalWidth
  const findAllCombinationsWithMeetInTheMiddle = (products, totalWidth) => {
    const half1 = products.slice(0, Math.floor(products.length / 2));
    const half2 = products.slice(Math.floor(products.length / 2));

    // Function to generate all subsets of a list of products
    function generateSubsets(products) {
      const subsets = [];
      const n = products.length;
      for (let i = 0; i < 1 << n; i++) {
        let subset = [];
        let width = 0;
        for (let j = 0; j < n; j++) {
          if (i & (1 << j)) {
            // Check if the j-th bit is set
            subset.push(products[j]);
            width += products[j].width;
          }
        }
        subsets.push({ subset, width });
      }
      return subsets;
    }

    // Generate subsets for both halves
    const subsets1 = generateSubsets(half1);
    const subsets2 = generateSubsets(half2);

    // Filter subsets where the width <= totalWidth
    const validSubsets1 = subsets1.filter((s) => s.width <= totalWidth);
    const validSubsets2 = subsets2.filter((s) => s.width <= totalWidth);

    // Combine valid subsets from both halves
    let results = [];
    for (const subset1 of validSubsets1) {
      for (const subset2 of validSubsets2) {
        if (subset1.width + subset2.width <= totalWidth) {
          results.push([...subset1.subset, ...subset2.subset]);
        }
      }
    }

    return results;
  };

  const addEventListenerToAddToCart = () => {
    const addToCartButton = node.querySelectorAll('[data-closet-add-to-cart]');
    addToCartButton.forEach((button) => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantIds = button
          .getAttribute('data-closet-add-to-cart')
          .split(',');

        const itemToAdd = variantIds.map((id) => {
          return {
            id: Number(id),
            quantity: 1,
          };
        });

        await addToCart(itemToAdd);

        // Emit event to open cart
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    });
  };

  // render color options
  const fillColorOptions = (products) => {
    let colors = [];

    products.forEach((product) => {
      if (!Array.isArray(product.metafields)) return;

      product.metafields.forEach((metafield) => {
        if (
          !metafield ||
          !metafield.references ||
          !Array.isArray(metafield.references.edges) ||
          metafield.key !== 'color-pattern'
        )
          return;

        metafield.references.edges.forEach((ref) => {
          const metaobject = ref.node;
          const entry = { color: null, label: null, image: null, id: null };

          metaobject.fields.forEach((field) => {
            entry.id = metaobject.id;
            if (field.key === 'color') entry.color = field.value;
            if (field.key === 'label') entry.label = field.value;
            if (field.key === 'image' && field.reference?.image?.url) {
              entry.image = field.reference.image.url;
            }
          });

          // Only push if at least one value is present
          if (entry.color || entry.label || entry.image) {
            colors.push(entry);
          }
        });
      });
    });

    // remove duplicates by id
    colors = colors.filter(
      (color, index, self) => index === self.findIndex((t) => t.id === color.id)
    );

    const colorFilter = node.querySelector('[data-filter-color]');

    colors.forEach((color, index) => {
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'color';
      input.value = color.label;
      input.id = color.id;
      input.classList.add('hidden');
      if (index === 0) {
        input.checked = true;
      }
      input.classList.add('mr-2', '!border-solid', 'border', 'peer');
      const label = document.createElement('label');
      label.htmlFor = color.id;
      label.classList.add(
        'flex',
        'flex-col',
        'w-[100px]',
        'h-full',
        'items-center',
        'gap-4',
        'group'
      );
      label.appendChild(input);

      const div = document.createElement('div');
      div.classList.add(
        'border',
        'border-solid',
        'border-gray-20',
        'rounded-lg',
        'outline-[2px]',
        'outline-offset-2',
        'group-hover:border-carmine',
        'peer-checked:border-carmine'
      );
      if (color.image) {
        const image = document.createElement('img');
        image.src = color.image;
        image.alt = color.color;
        image.classList.add(
          'w-[100px]',
          'h-[100px]',
          'rounded-lg',
          'border',
          'border-solid',
          'border-gray-20'
        );
        div.appendChild(image);
      } else {
        div.style.backgroundColor = color.color;
        div.classList.add(
          'w-[100px]',
          'h-[100px]',
          'rounded-lg',
          'border',
          'border-solid',
          'border-gray-20'
        );
      }
      label.appendChild(div);

      const divLabel = document.createElement('div');
      divLabel.classList.add('text-xs-medium');
      divLabel.textContent = color.label;
      label.appendChild(divLabel);

      colorFilter.appendChild(label);
    });
  };

  const fillShelfStyleOptions = (products) => {
    let shelves = [];

    products.forEach((product) => {
      if (!Array.isArray(product.metafields)) return;

      product.metafields.forEach((metafield) => {
        if (
          !metafield ||
          !metafield.references ||
          !Array.isArray(metafield.references.edges) ||
          metafield.key !== 'style'
        )
          return;

        metafield.references.edges.forEach((ref) => {
          const metaobject = ref.node;
          const entry = { label: null, image: null, id: null };

          metaobject.fields.forEach((field) => {
            entry.id = metaobject.id;
            if (field.key === 'label') entry.label = field.value;
            if (field.key === 'image' && field.reference?.image?.url) {
              entry.image = field.reference.image.url;
            }
          });

          // Only push if at least one value is present
          if (entry.label || entry.image) {
            shelves.push(entry);
          }
        });
      });
    });

    // remove duplicates by id
    shelves = shelves.filter(
      (shelf, index, self) => index === self.findIndex((t) => t.id === shelf.id)
    );

    const shelfFilter = node.querySelector('[data-filter-shelf]');

    shelves.forEach((shelf, index) => {
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.name = 'shelf';
      input.value = shelf.label;
      input.id = shelf.id;
      input.classList.add('hidden');
      if (index === 0) {
        input.checked = true;
      }
      input.classList.add('mr-2', '!border-solid', 'border', 'peer');
      const label = document.createElement('label');
      label.htmlFor = shelf.id;
      label.classList.add(
        'flex',
        'flex-col',
        'w-[100px]',
        'h-full',
        'items-center',
        'gap-4',
        'group'
      );
      label.appendChild(input);

      const div = document.createElement('div');
      div.classList.add(
        'border',
        'border-solid',
        'border-gray-20',
        'rounded-lg',
        'outline-[2px]',
        'outline-offset-2',
        'group-hover:border-carmine',
        'peer-checked:border-carmine'
      );
      if (shelf.image) {
        const image = document.createElement('img');
        image.src = shelf.image;
        image.alt = shelf.label;
        image.classList.add(
          'w-[100px]',
          'h-[100px]',
          'rounded-lg',
          'border',
          'border-solid',
          'border-gray-20'
        );
        div.appendChild(image);
      }
      label.appendChild(div);

      const divLabel = document.createElement('div');
      divLabel.classList.add('text-xs-medium');
      divLabel.textContent = shelf.label;
      label.appendChild(divLabel);

      shelfFilter.appendChild(label);
    });
  };

  const setMinMax = (products) => {
    let minWidth = 0;
    let maxWidth = 0;
    let minDepth = 0;
    let maxDepth = 0;

    // find the min and max width and depth
    products.forEach((product) => {
      if (product.metafields) {
        product.metafields.forEach((metafield) => {
          if (metafield && metafield.key === 'width') {
            const width = Number(metafield.value);
            if (minWidth === 0 || width < minWidth) {
              minWidth = width;
            }
            if (width > maxWidth) {
              maxWidth = width;
            }
          }
          if (metafield && metafield.key === 'depth') {
            const depth = Number(metafield.value);
            if (minDepth === 0 || depth < minDepth) {
              minDepth = depth;
            }
            if (depth > maxDepth) {
              maxDepth = depth;
            }
          }
        });
      }
    });

    widthRange.setAttribute('min', 0);
    widthRange.setAttribute('max', maxWidth * 2);
    widthRange.setAttribute('value', maxWidth * 2);

    const widthLabel = node.querySelector(
      `#${widthRange.getAttribute('data-filter-width')}`
    );
    widthLabel.innerHTML = `${maxWidth * 2}&Prime;`;

    filterDepth.setAttribute('min', 0);
    filterDepth.setAttribute('max', maxDepth);
    filterDepth.setAttribute('value', maxDepth);

    const depthLabel = node.querySelector(
      `#${filterDepth.getAttribute('data-filter-depth')}`
    );
    depthLabel.innerHTML = `${maxDepth}&Prime;`;
  };

  const updateThumbLabel = (e) => {
    const slider = e.target;

    const labelElement = slider.dataset.labelName;
    const label = node.querySelector(`#${labelElement}`);
    const val = Number(slider.value);
    const min = Number(slider.min);
    const max = Number(slider.max);

    // Calculate the percent
    const percent = (val - min) / (max - min);

    // Get slider width and thumb offset
    const sliderWidth = slider.offsetWidth;
    const thumbWidth = 20; // matches the Tailwind-defined thumb size (h-5 = 20px)

    slider.style.background = `linear-gradient(to right, #404957 0%, #404957 ${percent * 100}%, #e5e7eb ${percent * 100}%, #e5e7eb 100%)`;

    // Set label position
    const position = sliderWidth * percent - thumbWidth / 2;
    label.style.left = `${position}px`;
    label.innerHTML = `${val}&Prime;`;
  };

  const init = async () => {
    widthRange.addEventListener('input', updateThumbLabel);
    filterDepth.addEventListener('input', updateThumbLabel);
    products = await fetchAllProducts();

    fillColorOptions(products);
    fillShelfStyleOptions(products);
    setMinMax(products);

    findProductsButton.addEventListener('click', findProducts);
  };
  init();
};
